import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// Components
import Container from '../../Components/Container';
import Footer from '../../Components/Footer';
// Slices
import {
	setUserEmail,
	setUserName,
	setUserLastname,
	setUserCode,
	setActiveLoginModal,
} from '../../app/features/userSlice';
// Services
import { getInfoUserForm } from '../../services/getInfoUserForm';
import { getInfoUserTalent } from '../../services/getInfoUserTalent';
// Images
import aquinoLogin from '../../Images/Login/LoginPage/aquinoLogin.svg';
// Icons
import { HiOutlineUser } from 'react-icons/hi';
import { RiLockPasswordLine } from 'react-icons/ri';
import { IoChevronBackOutline } from 'react-icons/io5';
// Styles
import './LoginPage.css';
import { handleGetFavorites } from '../../Components/FavoriteButton/utils';
// Translate
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const { institutionCode } = useSelector((state) => state.institution);

	// Variables
	const [passForm, setPassForm] = useState('');
	const [emailForm, setEmailForm] = useState('');
	const [usernameForm, setUsernameForm] = useState('');
	const [errorInLogin, setErrorInLogin] = useState(false);

	const getDataTalent = (user, email) => {
		getInfoUserTalent()
			.then((response) => {
				const userSearched = {
					login: user,
					email: email,
				};

				for (const user of response.data) {
					if (
						user.email === userSearched.email &&
						user.login === userSearched.login
					) {
						handleGetFavorites(user?.email, dispatch);
						dispatch(setUserEmail(user.email));
						dispatch(setUserName(user.first_name));
						dispatch(setUserLastname(user.last_name));
						dispatch(setUserCode(user.login_key));
						navigate(`/`);
						return null;
					}
				}
				showError();
			})
			.catch((error) => {
				console.error('Request error:', error);
			});
	};

	const getDataUserForm = (user, pass) => {
		getInfoUserForm(user, pass)
			.then((response) => {
				if (response.status === 200) {
					handleGetFavorites(response?.data?.username, dispatch);
					dispatch(setUserEmail(response.data.username));
					dispatch(setUserName(response.data.username));
					dispatch(setActiveLoginModal(false));
					navigate(`/search`);
				} else {
					showError();
				}
			})
			.catch((error) => {
				console.error('Request error:', error);
			});
	};

	const showError = () => {
		setErrorInLogin(true);
		setTimeout(() => {
			setErrorInLogin(false);
		}, '6000');
	};

	return (
		<main className='loginPage'>
			<Container className='loginPageContainer'>
				<button className='backLoginButton' onClick={() => navigate('/')}>
					<IoChevronBackOutline />
					{t('Return')}
				</button>
				<section className='loginContainer'>
					<img src={aquinoLogin} alt='Aquino' />
					<p className='info'>
						{t('Welcome to')} <b>Aquinas Online Library</b>
						<br /> <b>{t('Log in')}</b> {t('to your account and')}{' '}
						<b>{t('explore our resources')}</b>
					</p>
					<form
						className='formLogin'
						onSubmit={(e) => {
							e.preventDefault();
							institutionCode === 'MIAMI_BROWARD'
								? getDataTalent(usernameForm, emailForm)
								: getDataUserForm(usernameForm, passForm);
						}}
					>
						<div className='formLogin__inputs'>
							<div>
								<div className='input-container'>
									<label>{t('User')}:</label>
									<input
										onChange={(e) => setUsernameForm(e.target.value)}
										type='text'
										name='name'
										placeholder={t('Email or username')}
										required
									/>
									<HiOutlineUser />
								</div>
							</div>
							<div>
								<div className='input-container'>
									<label>
										{institutionCode === 'MIAMI_BROWARD'
											? t('Email')
											: t('Password')}
									</label>
									<input
										onChange={(e) => {
											institutionCode === 'MIAMI_BROWARD'
												? setEmailForm(e.target.value)
												: setPassForm(e.target.value);
										}}
										type={
											institutionCode === 'MIAMI_BROWARD' ? t('Email') : t('Password')
										}
										name='name'
										placeholder={
											institutionCode === 'MIAMI_BROWARD' ? t('Email') : t('Password')
										}
										required
									/>
									<RiLockPasswordLine />
								</div>
							</div>
						</div>
						<button className='btnLogin' type='submit'>
							{t('Login')}
						</button>
					</form>

					{institutionCode === 'CMVC' && (
						<p className='descriptive'>
							{t('Happy reading! Welcome to your personalized Virtual Library')}{' '}
							<b>library@compumed.edu</b>. {t('Check Moodle for the latest updates')}
						</p>
					)}
					{errorInLogin && (
						<p className='errorMessage'>{t('Email or username are incorrect')}</p>
					)}
				</section>
				<section className='infoSectionContrainer'>
					<Link to={'/signup'} className='aux-text'>
						{t('Need to create an account?')}
					</Link>
					<Link to={'/recover'} className='aux-text'>
						{t('Forgot your password?')}
					</Link>
				</section>
			</Container>
			<Footer allContent={false} />
		</main>
	);
};

export default LoginPage;
